export default((callback,delay)=>{let timeout;return()=>{if(timeout){clearTimeout(timeout)}timeout=setTimeout(callback,delay)}});